import { RequestBase, ResponseBase, ResponseBasePage } from "src/app/modules/fwcore/models";
import { HelpGlossaryScope } from "src/app/features/prob/models";

/**
 * Request the Help item to glossary scope mappings.
 *
 * The reader asks for the whole set once and joins it to the tree it already holds,
 * rather than asking per page - two dozen rows against a tree of tens, so there is
 * nothing to page and no filter worth sending.
 */
export class RequestHelpGlossaryScope extends RequestBase {

  /** One item's mapping. Leave unset for every mapping, which is what the reader does. */
  helpItemId?: string | null;
}

/**
 * Response carrying the Help item to glossary scope mappings.
 *
 * An empty data array is a NORMAL result. Nothing is mapped until an author maps it,
 * and a page with no mapping simply offers no Glossary tab.
 */
export class ResponseHelpGlossaryScope extends ResponseBasePage<HelpGlossaryScope> {
}

/**
 * Set, change or clear one Help item's glossary scope.
 *
 * ALL THREE IDS UNSET CLEARS THE MAPPING, and that is the only way to clear it - the
 * row is deleted rather than blanked, because the reader's only question is whether a
 * mapping exists.
 *
 * Send the ids that IDENTIFY the scope - dealGroupId, dealTypeId and towerId from
 * GlossaryScope - not the three request... ids. Those exist for reading terms, and the
 * two sets deliberately differ.
 */
export class RequestHelpGlossaryScopeSet extends RequestBase {

  helpItemId?: string | null;
  dealGroupId?: string | null;
  dealTypeId?: string | null;
  towerId?: string | null;
}

/**
 * Response reporting what setting a glossary scope did.
 *
 * isMapped is what tells a clear from a set, so the editor can show or hide the reader's
 * Glossary tab without re-reading the mapping.
 *
 * A scope holding no terms comes back as 400 carrying the procedure's message, not as a
 * success with isMapped false. An author must be able to tell an empty scope from a
 * failed save.
 */
export class ResponseHelpGlossaryScopeSet extends ResponseBase {

  helpItemId?: string | null;
  isMapped?: boolean | null;
}
